import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import BentoIcon from './BentoIcon';
import RichTooltip from './RichTooltip';

const RichTooltipContent = styled('div')({ maxWidth: '18vw', fontSize: '0.8125rem' });

interface ServiceDowncodedProps {
  service: {
    code?: string | null;
    downcoded_from?: string | null;
    downcoded_description?: string | null;
  };
}

export default function ServiceDowncoded({ service }: ServiceDowncodedProps) {
  const isDowncoded = !!service.downcoded_from;

  return (
    <Stack spacing={1} direction="row">
      {isDowncoded && (
        <Typography
          fontSize="inherit"
          sx={{
            textDecoration: 'line-through',
          }}
        >
          {service.downcoded_from}
        </Typography>
      )}
      <Typography fontSize="inherit">{service.code}</Typography>
      {isDowncoded && (
        <RichTooltip
          placement="top"
          content={
            <RichTooltipContent>
              <Typography fontWeight={700} fontSize="inherit">
                Explanation: Downcoded
              </Typography>
              <Typography fontSize="inherit">{service.downcoded_description}</Typography>
            </RichTooltipContent>
          }
        >
          <BentoIcon fontSize="inherit" name="circle-question" color="inherit" />
        </RichTooltip>
      )}
    </Stack>
  );
}
